import React, { useEffect, useState } from 'react'
import { Card, BoxCard, LinkCard, CardMessage } from '../../styles.style'
import { MuvicardService } from '../../../../services/muvicard.service'
import { StorageService } from '../../../../services/storage.service'

const NewCard = ({ user, hideLoading }) => {
	let [resultCard, setResultCard] = useState({})

	useEffect(() => {
		hideLoading()

		MuvicardService.GetCardInfo().then(data => {
			if (data.success) {
				if (data.data) {
					const {
						invoiceExpirationDay,
						cardProposalId,
						originalLimitValue
					} = data.data

					setResultCard({
						cardProposalId,
						originalLimitValue,
						invoiceExpirationDay
					})
					let user = StorageService.authentication.user.get()
					user.hasMuvicard = true
					StorageService.authentication.user.set(user)
				}
			}
		})
	}, [])
	return (
		<Card>
			<BoxCard>
				<ul>
					<li>
						<strong>{user.name}</strong>
					</li>
					<li>
						<span>
							Número da proposta:{' '}
							{resultCard.cardProposalId
								? resultCard.cardProposalId.padStart(6, '0')
								: ''}
						</span>
					</li>
					<li>
						<span>
							Limite disponível:{' '}
							{resultCard.originalLimitValue != undefined
								? resultCard.originalLimitValue.$toReais()
								: resultCard.originalLimitValue}
						</span>
					</li>
					<li>
						<span>
							Dia de vencimento: {resultCard.invoiceExpirationDay}
						</span>
					</li>
				</ul>
			</BoxCard>

			<CardMessage>
				Pronto! Agora você já <br />
				possui um cartão Muvicard!
			</CardMessage>

			<LinkCard href="/" title="Comprar passagem" className="orange">
				Comprar passagem
			</LinkCard>

			<LinkCard
				title="Ir para a seção Meu Cartão"
				href="/muvicard/meu-cartao"
				className="blue">
				Ir para "Meu Cartão"
			</LinkCard>
		</Card>
	)
}

export default NewCard
